import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class ContactBrfMembership extends ModelBase {
  constructor(data?: any) {
    super();

    Object.defineProperties(this, {
      _fromDate: { writable: true, enumerable: false },
      _toDate: { writable: true, enumerable: false },
      _approvalDate: { writable: true, enumerable: false },
    });

    if (data) {
      this.companyNumber = data.companyNumber;
      this.companyName = data.companyName;
      this.fromDate = data.fromDate;
      this.toDate = data.toDate;
      this.approvalDate = data.approvalDate;
    }
  }

  companyNumber: number;
  companyName: string;

  private _fromDate: LocalDate;
  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  private _toDate: LocalDate;
  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  private _approvalDate: LocalDate;
  get approvalDate(): LocalDate {
    return this._approvalDate;
  }
  set approvalDate(value: LocalDate) {
    this._approvalDate = LocalDate.fromDate(value);
  }
}
